export const ASSIGN_STAFF_STATUS = {
  APPROVED: 'approved',
}

export const globalSettingsTypes = {
  BULK_SMS_REPLY_STOP_OUTPUT: 'bulkSMSReplyStopOutout',
  BULK_MMS_REPLY_STOP_OUTPUT: 'bulkMMSReplyStopOutout',
  QUICK_SMS_REPLY_STOP_OUTPUT: 'quickSMSReplyStopOutout',
  QUICK_MMS_REPLY_STOP_OUTPUT: 'quickMMSReplyStopOutout',
  API_SMS_REPLY_STOP_OUTPUT: 'apiSMSReplyStopOutout',
  API_MMS_REPLY_STOP_OUTPUT: 'apiMMSReplyStopOutout',
  EMAIL_TO_SMS_REPLY_STOP_OUTPUT: 'emailToSMSReplyStopOutout',
  QUICK_MESSAGE_TO_UNSUB_CONTACT: 'sendQuickMessageToUnsubContact',
  BULK_MESSAGE_TO_UNSUB_CONTACT: 'sendBulkMessageToUnsubContact',
  SENDER_IDS_DISABLE_SEND_OTP: 'disableSendSenderIdVerificationCode',
  SEND_WITH_CUSTOM_PRICE: 'sendWithCustomPrice',
  DISABLE_FRAUD_KEYWORD: 'disableFraudKeywords',
  CUSTOM_FRAUD_KEYWORD: 'customFraudKeywords',
  INBOUND_SHARE_TO_ALL_SHARED_DN: 'inboundToAllSharedDN',
  NEW_NAVIGATION: 'navigationV2',
  NEW_NAVIGATION_V3: 'navigationV3',
  NEW_SUB_CLIENT_AUTO_VERIFY: 'newSubClientAutoVerify',
  NEW_INBOX: 'newInbox',
}
